import { accountService, eventService } from '../../services/homii-services';

const genders = {
    FEMALE: 1,
    MALE: 2,
};

async function signUp(firstName, lastName, email, phone, password, confirmPassword) {    
    try {
        const signUpResponse = await accountService.signUp(
            firstName,
            lastName,
            email,
            phone,
            password,
            confirmPassword,
        );
        eventService.logCustomEvent('successful_sign_up', {
            description: 'User successfuly signed up',
            firstName,
            lastName,
            email,
            phone,
        });
        return signUpResponse;
    } catch (error) {
        throw Error(error.response.data.message);
    }   
}

async function login(email, password) {
   
    if (!email || !password) {
        return;
    }   

    try {    
        const loginResponse = await accountService.login(email, password);
        eventService.logCustomEvent('successful_login', {
            description: `User with userId ${loginResponse.userId} successfully logged in`,
            user_id: loginResponse.userId,
            email,
        });        
        return loginResponse;
    } catch (error) {        
        if (_.get(error, 'response.status') === 403) {
            throw Error(
                'Incorrect email or password provided. Please ensure you have confirmed your email address.',
            );
        } else {
            throw Error(
                'Something went wrong while trying to log you in. Please ensure you have confirmed your email address.',
            );
        }
    }
    
}

async function setGender(gender) {
    try {
        await accountService.setGender(_.get(genders, _.upperCase(gender), 0));
        eventService.logCustomEvent('successful_set_gender', {
            description: `Successfuly set gender as ${gender}`,
            gender,
        });
    } catch (error) {
        throw Error(error.response.data.message);
    }
}

async function forgotPassword(emailAddress) {  
    try {
        const response = await accountService.forgotPassword(emailAddress);
        eventService.logCustomEvent('successful_forgot_password', {
            description: `Successfuly requested to reset password ${emailAddress}`,
            emailAddress,
        });
        return response;
    } catch (error) {
        throw Error(error.response.data.message);
    }   
}

async function resetPassword(emailAddress, newPassword, passwordResetOtp) { 
    try {
        const response = await accountService.resetPassword(
            emailAddress,
            newPassword,
            passwordResetOtp,
        );
        eventService.logCustomEvent('successful_reset_password', {
            description: 'Successfuly reset password',
            emailAddress,
            newPassword,
            passwordResetOtp,
        });
        return response;
    } catch (error) {
        throw Error(error.response.data.message);
    }   
}

export default {
    signUp,
    login,
    setGender,
    forgotPassword,
    resetPassword
}